import Swal from 'sweetalert2';
import { RemoteConstants } from '../../../data/remote/RemoteConstants';
import { UIActions } from '../../../presentation/redux/actions/UIActions';
import { errorManager } from '../../../presentation/utils/errorManager';
import { convertirFecha } from '../../../domain/utils/convertirFechas';

// Configuración  del toast
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  }
});

/* eslint-disable no-unused-vars */
export const posMovsComisiones = async (modalState, token, dispatch, setListMovs) => {
  try {
    const params = new URLSearchParams({
      token: token,
      fecha_ini: convertirFecha(modalState.date),
      fecha_fin: convertirFecha(modalState.dateEnd),
      file: false,
    });
    const peticion = await fetch(`${RemoteConstants.BASE_URL}pos/movs/comisiones?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(resp => {
        return resp.json();
      })
      .then(data => {
        if (data.code === 'OK') {
          Toast.fire({
            icon: "success",
            title: data.userMessage
          });
          setListMovs(data.data);
        } else {
          errorManager(data.userMessage);
        }
      });
  } catch (error) {
    errorManager(error);
  }
  dispatch(UIActions.uiLoadInactive());
}